module.exports = __webpack_public_path__ + "img/cadastrosnosultimos7dias.0be09063.png";